import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
const ClosingStatement = React.memo(() => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pharmviewData, setpharmviewData] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchpharmviewData();
        fetchData();
    }, [startDate, endDate]);
    function fetchpharmviewData() {
        axios.get(`${baseUrl}indent-pharm-search/?qty=gt0`)
            .then(response => {
                setpharmviewData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&status=1`;
        axios.get(url)
            .then(response => {
                transformData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const transformData = (data) => {
        // ✅ STEP 1: Build lookup map (O(M))
        const salesMap = {};
        data.forEach(item => {
            const productIDs = item.product ? item.product.split(",") : [];
            const quantities = item.qty ? item.qty.split(",") : [];
            const prices = item.netamount ? item.netamount.split(",") : [];
            productIDs.forEach((pid, i) => {
                if (!salesMap[pid]) {
                    salesMap[pid] = {qty: 0, amount: 0};
                }
                salesMap[pid].qty += parseInt(quantities[i] || 0);
                salesMap[pid].amount += parseFloat(prices[i] || 0);
            });
        });
        // ✅ STEP 2: Map stock (O(N))
        const transformedRows = pharmviewData.map(row => {
            const sale = salesMap[row.id] || {qty: 0, amount: 0};
            return {
                id: row.id,
                dept: row.dept,
                user: row.user,
                dist: row.product?.dist?.name || 'N/A',
                product: row.product?.product || 'N/A',
                batch: row.product?.batch || 'N/A',
                pack: row.product?.pack || 'N/A',
                qty: row.qty,
                expiry: row.product?.expiry || 'N/A',
                mrp: row.product?.mrp || 'N/A',
                pprice: row.product?.pprice || 'N/A',
                soldQty: sale.qty,
                soldAmount: sale.amount.toFixed(2)
            };
        });
        setRows(transformedRows);
    };
    const columns = [
        {field: 'id', headerName: 'ID', width: 30},
        {field: 'dept', headerName: 'Raised to', width: 110},
        {field: 'user', headerName: 'User', width: 80},
        {field: 'dist', headerName: 'Dist', width: 220},
        {field: 'product', headerName: 'Product', width: 220},
        {field: 'batch', headerName: 'Batch', width: 120},
        {field: 'pack', headerName: 'Pack', width: 50},
        {field: 'qty', headerName: 'Qty', width: 50},
        {field: 'expiry', headerName: 'Expiry', width: 100},
        {field: 'mrp', headerName: 'MRP', width: 80},
        {field: 'pprice', headerName: 'PPrice', width: 80},
        {field: 'soldQty', headerName: 'Sold Qty', width: 90},
        {field: 'soldAmount', headerName: 'Sold Amount', width: 120},
    ];
    const getTotal = (rows, field) => {
        let total = 0;
        if (field === 'qty') {
            total = rows.reduce((sum, row) => sum + parseFloat(row.qty), 0);
        } else if (field === 'mrp') {
            total = rows.reduce((sum, row) => sum + parseFloat(row.mrp), 0);
        } else if (field === 'pprice') {
            total = rows.reduce((sum, row) => sum + parseFloat(row.pprice), 0);
        } else if (field === 'soldQty') {
            total = rows.reduce((sum, row) => sum + parseFloat(row.soldQty), 0);
        } else if (field === 'soldAmount') {
            total = rows.reduce((sum, row) => sum + parseFloat(row.soldAmount), 0);
        }
        return total;
    };
    const Footer = ({rows}) => {
        const totalCurQty = getTotal(rows, "qty");
        const totalMrp = getTotal(rows, "mrp");
        const totalPprice = getTotal(rows, "pprice");
        const totalSoldQty = getTotal(rows, "soldQty");
        const totalSoldAmount = getTotal(rows, "soldAmount");
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>{totalCurQty ? totalCurQty : 'N/A'}</div>
                <div>{totalMrp ? totalMrp.toFixed(2) : 'N/A'}</div>
                <div>{totalPprice ? totalPprice.toFixed(2) : 'N/A'}</div>
                <div>{totalSoldQty ? totalSoldQty : 'N/A'}</div>
                <div>{totalSoldAmount ? totalSoldAmount.toFixed(2) : 'N/A'}</div>
            </div>
        );
    };
    const today = new Date();
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Closing Statement
                </h3>
                <div className="row">
                    <div className="col-md-4">
                        <label className="control-label">Select Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText={'Please select From date'}
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                        />
                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            maxDate={today}
                            placeholderText={'Please select To date'}
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                        />
                    </div>
                </div>
                {isLoading ? (
                    <div>Loading...</div>
                ) : (
                    startDate && endDate ? (
                        rows.length > 0 ? (
                            <div style={{height: '100%', width: '100%'}} className="mt-4">
                                <DataGrid
                                    sx={{
                                        boxShadow: 4,
                                        border: 4,
                                        borderColor: 'primary.light',
                                        '& .MuiDataGrid-cell:hover': {
                                            color: 'primary.main',
                                        },
                                    }}
                                    rows={rows}
                                    columns={columns}
                                    pageSize={10}
                                    slots={{
                                        toolbar: GridToolbar,
                                    }}
                                    initialState={{
                                        sorting: {
                                            sortModel: [{field: 'soldQty', sort: 'desc'}],
                                        },
                                    }}
                                    autoHeight
                                />
                            </div>
                        ) : (
                            <div>No data available for the selected date range</div>
                        )
                    ) : (
                        <div>Please select a date range</div>
                    )
                )}
                <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                    <tfoot>
                    <Footer rows={rows}/>
                    </tfoot>
                </table>
            </div>
        </section>
    )
});
export default ClosingStatement;
